import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as CopyIconSvg } from '../../assets/copy-icon.svg';

export const CopyIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={CopyIconSvg} {...props} />;
};
